import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/index'
import My from '@/views/my'
import Process from '@/views/process'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/my',
      name: 'my',
      component: My
    },
    {
      path: '/process',
      name: 'process',
      component: Process
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js